import React from 'react';
import { Tooltip } from '@material-ui/core';

const HoursIndicator = ({
  value,
  max,
  style,
}: {
  value: number;
  max: number;
  style: any;
}) => {
  let percentage = 0;
  if (value > max) {
    percentage = 100;
  } else {
    percentage = (value / max) * 100;
  }

  const containerStyle: any = {
    position: 'relative',
    width: '100%',
    height: '8px',
    backgroundColor: 'rgba(115, 188, 227, 0.1)',
    borderRadius: 'var(--ui-border-radius)',
    boxShadow: 'inset 0 1px 3px rgba(0, 5, 14, 0.5)',
    ...style,
  };

  const filledStyle: any = {
    width: `${percentage}%`,
    height: '100%',
    background: 'linear-gradient(90deg, #39b3ea 0%, #63d8ff 72%, #a6ecff 100%)',
    borderRadius: 'var(--ui-border-radius) 0 0 var(--ui-border-radius)',
    borderRight: '2px solid rgba(255, 255, 255, 0.62)',
    boxShadow: '0 0 10px rgba(57, 179, 234, 0.26)',
  };

  const totalMinutes = Math.round(value * 60); // Convert hours to total minutes
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return (
    <Tooltip title={`Used ${hours}h ${minutes}m out of ${max}h`}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={containerStyle}>
          <div style={filledStyle}></div>
        </div>
      </div>
    </Tooltip>
  );
};

export default HoursIndicator;
